import { createAction } from "redux-actions";
import { HERO_ACTIONS } from "./heroActions";
import { log } from "../../Helpers/logger";

export const USER_ACTIONS = {
  SET: 'user/set',
  CLEAR: 'user/clear',
  UPDATE_CHARACTER: 'user/update_character',
  SET_AUTH_STATUS: 'user/set_auth_status'
};

export const userActions = {
  setUser: createAction(USER_ACTIONS.SET, (userData) => ({
    id: userData.id,
    nickname: userData.nickname,
    email: userData.email || `${userData.nickname}@example.com`,
    gameData: userData.gameData || null,
    isAuthenticated: true,
    hasCharacter: !!(userData.gameData?.hero)
  })),

  clearUser: createAction(USER_ACTIONS.CLEAR),

  updateCharacter: createAction(USER_ACTIONS.UPDATE_CHARACTER, (characterData) => ({
    character: characterData
  })),

  setAuthStatus: createAction(USER_ACTIONS.SET_AUTH_STATUS, (isAuthenticated) => ({
    isAuthenticated
  })),
};

// Plain async helpers (formerly redux-thunks). Components import them
// directly: `await loginUser(dispatch, userData)`. No thunk middleware needed.
export const loginUser = async (dispatch, userData) => {
  const user = {
    id: userData.id,
    nickname: userData.nickname,
    email: userData.email || `${userData.nickname}@example.com`,
    gameData: userData.gameData || null,
    isAuthenticated: true,
    hasCharacter: !!(userData.gameData?.hero)
  };

  log.reducer.log('Dispatching login with user:', user);
  dispatch(userActions.setUser(user));

  if (user.gameData?.hero) {
    dispatch({
      type: HERO_ACTIONS.SET_HERO,
      payload: { hero: user.gameData.hero }
    });
  }

  return user;
};

export const logoutUser = async (dispatch) => {
  localStorage.removeItem('user');
  localStorage.removeItem('character');
  dispatch(userActions.clearUser());
};

export const updateUserCharacter = async (dispatch, characterData, currentUser) => {
  if (!characterData) {
    throw new Error('No character data provided');
  }

  log.reducer.log('Updating user character with data:', characterData);

  const hero = {
    id: characterData.id || `hero_${Date.now()}`,
    name: characterData.name || 'Hero',
    classType: characterData.classType || 'WARRIOR',
    gender: characterData.gender || 'male',
    level: characterData.level || 1,
    xp: characterData.xp || 0,
    gold: characterData.gold || 100,
    position: characterData.position || { mapId: 'map1', x: 0, y: 1 },
    stats: {
      strength: characterData.stats?.strength || 10,
      intelligence: characterData.stats?.intelligence || 10,
      dexterity: characterData.stats?.dexterity || 10,
      vitality: characterData.stats?.vitality || 10,
      health: characterData.stats?.health || 100,
      maxHealth: characterData.stats?.maxHealth || 100,
      mana: characterData.stats?.mana || 50,
      maxMana: characterData.stats?.maxMana || 50,
    },
    inventory: Array.isArray(characterData.inventory) ? characterData.inventory : [],
    updatedAt: new Date().toISOString(),
    createdAt: characterData.createdAt || new Date().toISOString()
  };

  dispatch({ type: HERO_ACTIONS.SET_HERO, payload: { hero } });
  dispatch({ type: 'character/update', payload: hero });

  const updatedUser = {
    ...currentUser,
    hasCharacter: true,
    gameData: {
      ...(currentUser?.gameData || {}),
      hero
    }
  };

  dispatch({ type: USER_ACTIONS.UPDATE_CHARACTER, payload: updatedUser });

  localStorage.setItem('character', JSON.stringify(hero));
  localStorage.setItem('user', JSON.stringify(updatedUser));

  log.reducer.log('User character updated and saved successfully');
  return hero;
};
